import { ItemFoodStock } from '../models/ItemFoodStock'
import { FoodStockRepository } from '../repositories/FoodStockRepository'

export function CreateItemFoodStock(foodStockRepository: FoodStockRepository) {
  return async function (data: ItemFoodStock) {
    return await foodStockRepository.createItemFoodStock(data)
  }
}
